<!--  -->
<template>
<div>
     <div class="layout-content" style="background: transparent;">
      <div>
        <Table ref="selection" :columns="columns" :data="list">
          <template slot-scope="{ row }" slot="keys">{{row.keys}}</template>
          <template slot-scope="{ row }" slot="keysCount">{{row.keysCount}}</template>
        </Table>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px;text-align: center;">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </div>
      <!-- <div class="u-empty" v-else>暂无数据</div> -->
    </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
data() {
return {
    columns: [
        {
          title: "关键字",
          slot: "keys",
          align: "center",
          //width: 240
        },
        {
          title: "数量",
          slot: "keysCount",
          align: "center",
          //width: 240
        }
      ],
      list: [],
      pageSize:20,
      pageIndex:1,
      totalCount:""

}
},
//生命周期 - 创建完成（访问当前this实例）
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
     
      getSearch: "hostCommonModule/getSearch"
    }),
    async init() {
    let opt={
    "AgentId": "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
    "pageSize":this.pageSize,
    "pageIndex": this.pageIndex,
    "sorts": [{ "propertyName": "keysCount", "ascending": false }],
    "Wheres": {
        "Type": 1, 
        "Wheres": {
            "Label": "clientType",
            "Value": "1"
        }
    }
    }
      let data=await this.getSearch(opt)
      if(data&&data.items&&data.items.length>0){
          this.list=data.items
      }
      this.totalCount=data.totalCount
      console.log(data,'获取的结果');
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    // changePage(e) {
    //   this.pageIndex = e;
    //   this.init();
    // },
    // changePageSize(e) {
    //   this.pageSize = e;
    //   this.init();
    // },
  }

}
</script>
<style scoped lang='scss'>
/* @import url(); 引入css类 */

</style>